import { useQuery } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

import { surveyGroupIdAtom } from '../../atoms'

import { useSurveyGroupFiltersQueryKey } from './useSurveyGroupFiltersQueryKey'

const document = graphql(`
  query SurveyGroupFilterInformation_SurveyGroupFilters($surveyGroupId: ID!) {
    surveyGroupFilters(surveyGroupId: $surveyGroupId) {
      id
      title
    }
  }
`)

export const useSurveyGroupFiltersQuery = () => {
  const graphQLRequest = useGraphQLRequest()
  const queryKey = useSurveyGroupFiltersQueryKey()
  const surveyGroupId = useAtomValue(surveyGroupIdAtom)

  return useQuery({
    enabled: exists(surveyGroupId),
    queryFn: () => graphQLRequest({ document, variables: { surveyGroupId } }),
    queryKey,
  })
}
